<template>
    <div v-if="companyDetails"
         class="pb-20">
        <hr class="my-40 lg:mb-70 lg:mt-120 text-gray-350">
        <h3 class="text-13 font-semi-bold mb-16">
            {{ $dictionary.get('Information.CreateAccount.HelpBlock.Heading') }}
        </h3>
        <div class="text-12 md:text-13">
            <div class="mb-8">
                {{ companyDetails.companyName }}
            </div>
            <div v-if="companyDetails.phoneNumber"
                 class="pb-8">
                <span class="theme-text-linkcolor inline-block">
                    <CIcon name="phone"
                           class="mr-10"/>
                </span>
                <span class="inline-block">{{ companyDetails.phoneNumber }}</span>
            </div>
            <div v-if="companyDetails.email"
                 class="pb-8">
                <a :href="'mailto:' + companyDetails.email"
                   target="_blank">
                    <span class="theme-text-linkcolor inline-block">
                        <CIcon name="mail"
                               class="mr-10"/>
                    </span>
                    {{ companyDetails.email }}
                </a>
            </div>
            <div v-if="companyDetails.openingHours"
                 class="mb-8">
                <span class="theme-text-linkcolor inline-block">
                    <CIcon name="clock"
                           class="mr-10"/>
                </span>
                <div class="inline-block">
                    {{ $dictionary.get('Footer.OpeningHoursTitle') }}:
                    {{ companyDetails.openingHours }}
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { OfficeViewObject } from '@/types/apiServerContract';
import { FooterCompanyDetails } from '@/types/contentServerContract';

const props = defineProps<{
    companyDetails: OfficeViewObject | FooterCompanyDetails | null;
}>();
</script>
